var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Planification',{attrs:{"matter_id":_vm.matter_id,"allows_crud":_vm.allows_crud}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }